export enum DocumentThumbnailType {
  THUMBNAIL_IMAGE = 1,
  COVERSHEET = 2,
  ADD_PAGE = 3,
  REQUEST_PAGE = 4,
}
